module.exports = __webpack_public_path__ + "images/Uploaded-file.cad347ced89740f31768979260716139.svg";